import { NgClass } from '@angular/common';
import { Component, HostListener, Inject, ViewChild, DOCUMENT } from '@angular/core';

import {
  NOTIFICATION_STATUS_FILTERS,
  NOTIFICATION_TYPE_FILTERS,
  NotificationListTab
} from '../notifications/notification.constants';
import { NotificationsListComponent } from '../notifications/notifications-list/notifications-list';

@Component({
  selector: 'app-notifications-page',
  templateUrl: './notifications-page.html',
  styleUrls: ['./notifications-page.scss'],
  imports: [NgClass, NotificationsListComponent]
})
export class NotificationsPageComponent {
  @ViewChild(NotificationsListComponent) notificationsList?: NotificationsListComponent;

  activeTab: NotificationListTab = 'all';
  private readonly scrollThreshold = 100;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  readonly statusFilters = NOTIFICATION_STATUS_FILTERS;
  readonly typeFilters = NOTIFICATION_TYPE_FILTERS;

  get activeLabel() {
    return [...this.statusFilters, ...this.typeFilters].find((filter) => filter.tab === this.activeTab)?.label || 'All';
  }

  get markAllLoading() {
    return this.notificationsList?.markAllLoading ?? false;
  }

  setActiveTab(tab: NotificationListTab) {
    this.activeTab = tab;
  }

  readAllClick() {
    this.notificationsList?.readAllClick();
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    const win = this.document.defaultView;
    const element = this.document.documentElement;

    if (!win || !element) {
      return;
    }

    const atBottom = element.scrollHeight - win.scrollY <= win.innerHeight + this.scrollThreshold;

    if (atBottom) {
      this.notificationsList?.loadMoreIfAvailable();
    }
  }
}
